interface ConstantProps {
    DAILY_REFRESH_KEY: "lastCountryDialingFetchTime";
    DOMESTIC: "domestic";
    INTERNATIONAL: "international";
    DOMESTIC_CODE: "DE";
    REDEEMABLE_IN_STORE: "in-store";
    REDEEMABLE_ONLINE: "online";
    REDEEMABLE_BOTH: "both";
    PRICE_TYPE_FIXED: "fixed";
    PRICE_TYPE_RANGE: "range";
    PARENT_CATEGORY_NAME: {
        GIFT_CARDS: "Gift Cards",
        GAMING: "Gaming",
        PHONE_REFILL: "Phone Refill",
        INTERNATIONAL_TOPUP: "International Top Up"
    },
}

const Constant:ConstantProps = {
    DAILY_REFRESH_KEY: "lastCountryDialingFetchTime",
    DOMESTIC: "domestic",
    INTERNATIONAL: "international",
    DOMESTIC_CODE: "DE",
    REDEEMABLE_IN_STORE: "in-store",
    REDEEMABLE_ONLINE: "online",
    REDEEMABLE_BOTH: "both",
    PRICE_TYPE_FIXED: "fixed",
    PRICE_TYPE_RANGE: "range",
    PARENT_CATEGORY_NAME: {
        GIFT_CARDS: "Gift Cards",
        GAMING: "Gaming",
        PHONE_REFILL: "Phone Refill",
        INTERNATIONAL_TOPUP: "International Top Up"
    },
};
export default Constant;
  